import React, { useEffect, useState } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import "../styles/PagesModern.css";
import CategoryIcon from "./CategoryIcon";
import { maskDriverName, isVisibleDriver, authHeaders } from "../utils/driverPrivacy";
import IracingPrivacyNotice from "./IracingPrivacyNotice";
import { CategoryFilter, PageHeader, PanelHeader, SegmentedControl } from "./RefreshUI";
import { CATEGORIES, CATEGORY_LABELS } from "../utils/racingLabels";

export const Leaderboards = () => {
	const navigate = useNavigate();
	const [topIRatings, setTopIRatings] = useState([]);
	const [topIRatingsLoading, setTopIRatingsLoading] = useState(true);
	const [topIRatingsCategory, setTopIRatingsCategory] = useState("combined");
	const [displayCount, setDisplayCount] = useState(25);

	// Fetch top iRatings leaderboard data
	useEffect(() => {
		const fetchTopIRatings = async () => {
			setTopIRatingsLoading(true);
			try {
				const response = await axios.get(`https://iracing6-backend.herokuapp.com/api/top-iratings/category/${topIRatingsCategory}`, { headers: authHeaders() });
				setTopIRatings(response.data);
				setTopIRatingsLoading(false);
			} catch (error) {
				console.error("Error fetching top iRatings:", error);
				setTopIRatingsLoading(false);
			}
		};
		fetchTopIRatings();
	}, [topIRatingsCategory]);

	const categoryLabel = topIRatingsCategory === "combined" ? "Combined" : CATEGORY_LABELS[topIRatingsCategory];

	return (
		<div className="pg">
			<main className="hp-main pg-main--narrow">
				<PageHeader title="iRating leaderboards" lede="The top 100 iRacing drivers in each category." />

				<section className="hp-panel">
					<PanelHeader title={categoryLabel}>
						<CategoryFilter
							label="Category"
							value={topIRatingsCategory}
							onChange={setTopIRatingsCategory}
							options={[
								{ value: "combined", title: "Combined", content: "Combined" },
								...CATEGORIES.map((cat) => ({ value: cat, title: CATEGORY_LABELS[cat], content: <CategoryIcon category={cat} size={16} /> })),
							]}
						/>
						<SegmentedControl
							label="Drivers shown"
							value={displayCount}
							onChange={setDisplayCount}
							options={[25, 50, 100].map((count) => ({ value: count, title: `Top ${count}`, content: `Top ${count}` }))}
						/>
					</PanelHeader>
					{!topIRatingsLoading && topIRatings.last_update && (
						<p className="hp-panel__note">Updated {new Date(topIRatings.last_update).toLocaleString()}</p>
					)}
					<IracingPrivacyNotice />

					{topIRatingsLoading ? (
						<div className="hp-board__loading">
							<div className="spinner"></div>
						</div>
					) : (
						<>
							<div className="pg-board-head" aria-hidden="true">
								<span>Rank</span>
								<span>Driver</span>
								<span>iRating</span>
							</div>
							<ol className="hp-board">
								{topIRatings.top_100?.slice(0, displayCount).map((driver, index) => {
									const visible = isVisibleDriver(driver.cust_id);
									return (
										<li key={driver.cust_id ?? `rank-${driver.rank}-${index}`}>
											<button
												type="button"
												className={`hp-board__row hp-board__row--p${driver.rank}`}
												disabled={!visible}
												title={visible ? undefined : "This driver hasn't chosen to share their name"}
												onClick={() => visible && navigate(`/user/careerstats/${driver.cust_id}`)}
											>
												<span className="hp-board__pos">{driver.rank}</span>
												<span className="hp-board__driver">
													<span className="hp-board__name">{maskDriverName(driver.display_name)}</span>
													{topIRatingsCategory === "combined" && driver.breakdown && (
														<span className="hp-board__split">
															{CATEGORIES.map((cat) => (
																<span key={cat} className="hp-board__cat" title={CATEGORY_LABELS[cat]}>
																	<CategoryIcon category={cat} size={12} />
																	{(driver.breakdown[cat] || 0).toLocaleString()}
																</span>
															))}
														</span>
													)}
												</span>
												<span className="hp-board__ir">
													{driver.irating?.toLocaleString()}
													<span className="hp-board__unit">iR</span>
												</span>
											</button>
										</li>
									);
								})}
							</ol>
						</>
					)}
				</section>
			</main>
		</div>
	);
};
